import { byteToKb, trimString } from '../../utils/converter';
import { MAX_FILE_SIZE } from '../../utils/config';
import ErrorIcon from '../../assets/icons/error.svg?react';

const ErrorModal = ({
  fileErrors,
  setFileErrors,
  rejectedFilesArray,
  setRejectedFilesArray,
  setShowErrorModal,
}) => {
  const handleClosePopup = () => {
    setShowErrorModal(false); // Close the popup
    setFileErrors([]);
    setRejectedFilesArray([]);
  };

  const renderFileErrors = () => {
    return fileErrors.map((error, i) => (
      <p key={i} className="text-center animate-fade-in-second">
        {error.message}
        {error.details && <p className="text-center animate-fade-in-second">{error.details}</p>}
      </p>
    ));
  };

  const renderRejectedFiles = () => {
    return (
      <div
        className="h-[340px] w-full flex flex-col gap-6 text-sm text-core-grey-60 
          overflow-scroll scroll-container scroll-container::-webkit-scrollbar"
      >
        {/* Files Too Large */}
        {rejectedFilesArray.some((file) => file.code === 'FILE_TOO_LARGE') && (
          <div className="animate-fade-in-second">
            <p className="text-[16px] text-center mb-2">
              File exceeds the {byteToKb(MAX_FILE_SIZE)} KB limit
            </p>
            <div className="flex flex-col gap-2 ">
              {rejectedFilesArray
                .filter((file) => file.code === 'FILE_TOO_LARGE')
                .map((file, i) => (
                  <div
                    key={i}
                    className="flex flex-row p-2 border border-slate-grey rounded-sm bg-core-black-contrast"
                  >
                    <p>{trimString(file.name)}</p>
                    <p className="ml-auto text-status-red">{byteToKb(file.size)} KB</p>
                  </div>
                ))}
            </div>
          </div>
        )}

        {/* Duplicate Files */}
        {rejectedFilesArray.some((file) => file.code === 'DUPLICATE') && (
          <div className="animate-fade-in-second">
            <p className="text-[16px] text-center mb-2">File data already exists</p>
            <div className="flex flex-col gap-2 ">
              {rejectedFilesArray
                .filter((file) => file.code === 'DUPLICATE')
                .map((file, i) => (
                  <div
                    key={i}
                    className="flex flex-row p-2 border border-slate-grey rounded-sm bg-core-black-contrast"
                  >
                    <p>{trimString(file.name)} </p>
                  </div>
                ))}
            </div>
          </div>
        )}

        {/* Unsupported Format */}
        {rejectedFilesArray.some((file) => file.code === 'UNSUPPORTED_FORMAT') && (
          <div className="animate-fade-in-second">
            <p className="text-[16px] text-center mb-2">Unsupported format</p>
            <div className="flex flex-col gap-2 ">
              {rejectedFilesArray
                .filter((file) => file.code === 'UNSUPPORTED_FORMAT')
                .map((file, i) => (
                  <div
                    key={i}
                    className="flex flex-row p-2 border border-slate-grey rounded-sm bg-core-black-contrast"
                  >
                    <p>{trimString(file.name)} </p>
                    <p className="ml-auto text-status-red">{file.type}</p>
                  </div>
                ))}
            </div>
          </div>
        )}

        {/* {rejectedFilesArray.some((file) => file.code === 'PROOF_FORMAT') && (
          <div className="animate-fade-in-second">
            <p className="text-[16px] text-center mb-2">JSON files can only...</p>
            <div className="flex flex-col gap-2 ">
              {rejectedFilesArray
                .filter((file) => file.code === 'PROOF_FORMAT')
                .map((file, i) => (
                  <div
                    key={i}
                    className="flex flex-row p-2 border border-slate-grey rounded-sm bg-core-black-contrast"
                  >
                    <p>{trimString(file.name)} </p>
                    <p className="ml-auto text-status-red">{file.type}</p>
                  </div>
                ))}
            </div>
          </div>
        )} */}
      </div>
    );
  };

  return (
    <div className=" flex flex-col h-full w-full items-center gap-4  ">
      {/* Spacer div to push content to center to bottom */}
      <div className="flex-grow"></div>

      <p className="text-[22px] font-normal animate-fade-in-first">
        {fileErrors.length > 0 ? 'Error' : 'Rejected files'}
      </p>
      <div>
        <ErrorIcon className="w-16 h-16 animate-fade-in-first" />
      </div>
      {fileErrors.length > 0
        ? renderFileErrors()
        : rejectedFilesArray.length > 0 && renderRejectedFiles()}

      {/* Spacer div to push button to bottom */}
      <div className="flex-grow"></div>
      <button
        onClick={handleClosePopup}
        className="btn-primary bg-minima-orange-2023 text-black 
        hover:bg-minima-orange-light transition-colors duration-600 ease-in-out"
      >
        Close
      </button>
    </div>
  );
};
export default ErrorModal;
